/* OERPLAN premium layer: scroll-reveal, tellers, progressbar */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll-progressbar ---------- */
  var bar = document.createElement('div');
  bar.id = 'oer-progress';
  document.body.appendChild(bar);
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      bar.style.width = (max > 0 ? (h.scrollTop / max) * 100 : 0) + '%';
      ticking = false;
    });
  }, { passive: true });

  if (reduced) return;

  /* ---------- Reveal-targets verzamelen ---------- */
  var selectors = [
    '.oer-hero__eyebrow', '.oer-hero__title', '.oer-hero__body', '.oer-hero__btn', '.oer-hero__usps',
    '.recovr-sp__stat', '.recovr-hiw__header', '.recovr-hiw__step',
    '.recovr-feats__header', '.recovr-feats__card',
    '.recovr-pain__eyebrow', '.recovr-pain__title', '.recovr-pain__body', '.recovr-pain__problem', '.recovr-pain__solution',
    '.recovr-faq__title', '.recovr-faq__subtitle', '.recovr-faq__item',
    '.recovr-guarantee__inner', '.recovr-cta__inner', '.recovr-trust__badge',
    '.oer-card', '.oer-transfo__media', '.oer-transfo__content'
  ];
  var seen = [];
  document.querySelectorAll(selectors.join(',')).forEach(function (el) { seen.push(el); });
  // Elementen die al in de liquid zelf data-oer-reveal hebben (zoals de transformatie-sectie) ook meenemen
  document.querySelectorAll('[data-oer-reveal]').forEach(function (el) {
    if (seen.indexOf(el) === -1) seen.push(el);
  });
  var els = seen;
  els.forEach(function (el) {
    el.setAttribute('data-oer-reveal', '');
    // Stagger: vertraging op basis van positie tussen dezelfde broertjes
    var parent = el.parentElement;
    if (parent) {
      var siblings = Array.prototype.filter.call(parent.children, function (c) {
        return c.hasAttribute && c.hasAttribute('data-oer-reveal');
      });
      var idx = siblings.indexOf(el);
      if (idx > 0) el.style.setProperty('--oer-d', Math.min(idx * 0.12, 0.6) + 's');
    }
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('oer-in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { io.observe(el); });

  /* ---------- Tellers in de social proof-balk ---------- */
  var counters = document.querySelectorAll('.recovr-sp__number');
  var cio = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      cio.unobserve(entry.target);
      var el = entry.target;
      var raw = el.textContent.trim();
      var m = raw.match(/^([^\d]*)(\d+)(.*)$/);
      if (!m) return;
      var prefix = m[1] || '';
      var target = parseInt(m[2], 10);
      var suffix = m[3] || '';
      var t0 = null;
      var dur = 1200;
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + Math.round(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.5 });
  counters.forEach(function (el) { cio.observe(el); });

  /* ---------- Accelerated checkout: "Kopen" → "Start jouw Oerplan →" ---------- */
  /* De ongebrande buy-it-now-knop wordt door Shopify's script gerenderd; tekst is
     niet via thema/locales instelbaar. Branded wallets (Shop Pay e.d.) blijven af. */
  var KOOPTEKST = 'Start jouw Oerplan →';
  function relabelBuyButton() {
    document.querySelectorAll('.shopify-payment-button__button--unbranded').forEach(function (btn) {
      if (btn.textContent.trim() && btn.textContent.indexOf('Start jouw Oerplan') === -1) {
        btn.textContent = KOOPTEKST;
      }
    });
  }
  /* ---------- Sticky-bar: knop werkt niet (geen hoofd-addknop meer) → direct naar checkout ---------- */
  function oerVariantId() {
    try {
      var el = document.querySelector('shopify-accelerated-checkout');
      var p = el && JSON.parse(el.getAttribute('variant-params'));
      if (p && p[0] && p[0].id) return p[0].id;
    } catch (e) { /* val terug op vaste id */ }
    return 57876016005464;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.sticky-add-to-cart__button');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = '/cart/' + oerVariantId() + ':1';
  }, true);

  function relabelSticky() {
    var btn = document.querySelector('.sticky-add-to-cart__button');
    if (!btn || btn.dataset.oerLabeled) return;
    var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (/winkelwagen/i.test(node.textContent)) {
        node.textContent = 'Start jouw Oerplan →';
        btn.dataset.oerLabeled = '1';
        break;
      }
    }
  }

  var buyObserver = new MutationObserver(function () { relabelBuyButton(); relabelSticky(); });
  buyObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
  relabelBuyButton();
  relabelSticky();
})();
